export const DEFAULT_MANUAL_INTEGRATION_SYSTEM = "Manual";
export const DEFAULT_DATA_FREQUENCY = 0; // Defaults to Days
export const NOURISH_INTEGRATION_SYSTEM = "Nourish";
export const NOURISH_INTEGRATION_TOKEN_FIELD_CODE = "nourishIntegrationToken";
export const INTEGRATION_SYSTEM_REQUIRED_VALIDATION = "_Required";
export const INTEGRATION_SYSTEM_SWITCH_FIELD = "_Switch";
